var modules = {
}

const files = require.context('.', true, /\.vue$/)
files.keys().forEach(key => {
  modules[key.substring(key.lastIndexOf('/') + 1, key.lastIndexOf('.'))] = files(key).default
})

const install = function (Vue, opts = {}) {
  Object.keys(modules).forEach(key => {
    var component = modules[key]
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
export default install



// WEBPACK FOOTER //
// ./src/components/editor/index.js